// extracted by mini-css-extract-plugin
export default {"semesterSwitcher":"MpU4RhiB","semesterName":"VZkQjidT"};